import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './../../shared/pipes/safe-html.pipe';
import { FolderFilterPipe } from './../../shared/pipes/folder-filter.pipe';
import { MyFilterPipe } from './../../shared/pipes/my-filter.pipe';
import { FilterUniqueNamePipe } from './../../shared/pipes/unique-name.pipe';
import { TruncatePipe } from './../../shared/pipes/truncate.pipe';
import { ReversePipe } from './../../shared/pipes/reverse.pipe';
import { OrderByPipe } from './../../shared/pipes/order-by.pipe';
import { ConvertFrom24To12FormatPipe } from './../../shared/pipes/convert-from24-to12-format.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomInputComponent } from './../../shared/custom-input/custom-input.component';
import { BreadcrumbComponent } from './../../breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { faStackOverflow, faGithub, faMedium } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {
	faRedoAlt, faRedo, faSync, faMale, faFemale, faSquare, faCheckSquare, faMedkit, faAmbulance, faBrain, faShip, faHome, faPowerOff, faLock, faCloudDownloadAlt, faSpinner, faTh, faAngleDown, faAngleUp, faTimes, faUser, faUsers, faEnvelope, faBookMedical, faFileMedical, faFileMedicalAlt, faPumpMedical, faNotesMedical, faClinicMedical, faLaptopMedical, faCommentMedical, faBriefcaseMedical, faHandHoldingMedical, faCheck, faMinus, faCalendar, faCalendarAlt, faCalendarWeek, faFilter, faPlus, faPencilAlt, faTrash, faKey, faUserAlt, faUserPlus, faUserCircle, faCapsules, faTablet, faTablets, faTabletAlt, faSave, faSignOutAlt, faHelicopter, faBuilding, faFlag, faDatabase, faCity, faEye, faEyeSlash, faStar, faInfo, faInfoCircle, faChalkboard, faFlagCheckered, faEdit, faUpload, faFileExcel, faFileVideo, faFilePdf, faFileImage, faFileArchive, faFileAudio, faTimesCircle, faFile, faPhone, faRupeeSign, faPrint, faLockOpen, faDownload, faListOl, faSun, faMoon, faExclamationTriangle, faExclamationCircle, faTrashAlt, faLink, faUnlink, faUserMd, faGraduationCap, faAward, faSchool, faSortDown, faSortUp, faSort, faSortAlphaDown, faSortAlphaUp, faSortAlphaDownAlt, faSortAlphaUpAlt, faHospital, faPhoneAlt, faThList, faCalendarDay, faFlask, faAngleDoubleUp, faHandsHelping, faHandshake, faInbox, faPaperPlane, faEnvelopeOpen, faSyncAlt,
	faDollarSign,
	faIndustry,
	faFileInvoice,
	faFileInvoiceDollar,
	faMoneyBillWave,
	faLongArrowAltLeft,
	faLongArrowAltRight,
	faNewspaper,
	faTasks,
	faClock,
	faUserClock,
	faUserCheck,
	faUserTimes,
	faSquareFull,
	faCopy,
	faGift,
	faGifts,
	faFileCsv,
	faFileWord,
	faFileAlt,
	faMedal,
	faTrophy,
	faCertificate,
	faListAlt,
	faList
} from '@fortawesome/free-solid-svg-icons';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { NgbModule, NgbDatepickerModule, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DataTablesModule } from 'angular-datatables';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule } from 'ngx-quill';
/* import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown'; */
import { FileIconComponent } from '../file-icon/file-icon.component';
import { FilePreviewComponent } from '../file-preview/file-preview.component';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { environment } from '../../../environments/environment';
import { ChangePasswordFormComponent } from '../../masters/users/change-password-form/change-password-form.component';
/* import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'; */
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CalendarDateFormatter, CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ColorPickerModule } from 'ngx-color-picker';
import { CustomDateFormatter } from '../constants';

@NgModule({
	declarations: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		CustomInputComponent,
		BreadcrumbComponent,
		FileIconComponent,
		FilePreviewComponent,
		SafeUrlPipe,
		ChangePasswordFormComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule.forRoot(),
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		MatChipsModule,
		/* NgMultiSelectDropDownModule.forRoot(), */
		PdfViewerModule,
		ScrollingModule,
		AutocompleteLibModule,
		/* RxReactiveFormsModule, */
		DragDropModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory,
		}),
		ColorPickerModule
	],
	exports: [
		SafeHtmlPipe,
		FolderFilterPipe,
		TruncatePipe,
		MyFilterPipe,
		ReversePipe,
		FilterUniqueNamePipe,
		OrderByPipe,
		ConvertFrom24To12FormatPipe,
		MatFormFieldModule,
		CustomInputComponent,
		BreadcrumbComponent,
		RouterModule,
		FontAwesomeModule,
		MatInputModule,
		MatProgressBarModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		ToastrModule,
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		NgxFileDropModule,
		QuillModule,
		MatMenuModule,
		NgxChartsModule,
		MatPaginatorModule,
		MatGridListModule,
		NgbDatepickerModule,
		MatChipsModule,
		/* NgMultiSelectDropDownModule, */
		FileIconComponent,
		FilePreviewComponent,
		SafeUrlPipe,
		PdfViewerModule,
		ScrollingModule,
		AutocompleteLibModule,
		ChangePasswordFormComponent,
		/* RxReactiveFormsModule, */
		DragDropModule,
		CalendarModule,
		ColorPickerModule
	],
	providers: [
		{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
		/* { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter } */
		{ provide: CalendarDateFormatter, useClass: CustomDateFormatter }
	],
})
export class CommonImportsModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faListAlt, faList, faCertificate, faTrophy, faAward, faMedal, faFileAlt, faFileWord, faFileCsv, faGifts, faGift, faCopy, faSquareFull, faUserTimes, faUserCheck, faUserClock, faClock, faTasks, faNewspaper, faLongArrowAltRight, faLongArrowAltLeft, faDollarSign, faRedoAlt, faRedo, faUserPlus, faUserCircle, faSync, faMale, faFemale, faStackOverflow, faGithub, faMedium, faSquare, faCheckSquare, faMedkit, faAmbulance, faBrain, faShip, faHome, faPowerOff, faLock, faSpinner, faTh, faAngleDown, faAngleUp, faTimes, faUser, faUsers, faUserAlt, faEnvelope, faBookMedical, faFileMedical, faFileMedicalAlt, faPumpMedical, faNotesMedical, faClinicMedical, faLaptopMedical, faCommentMedical, faBriefcaseMedical, faHandHoldingMedical, faCheck, faMinus, faCalendar, faCalendarAlt, faCalendarWeek, faFilter, faPlus, faPencilAlt, faTrash, faLock, faKey, faCapsules, faTablet, faTablets, faTabletAlt, faSave, faSignOutAlt, faHelicopter, faBuilding, faFlag, faDatabase, faCity, faEye, faEyeSlash, faStar, faCalendar, faInfo, faInfoCircle, faChalkboard, faFlagCheckered, faEdit, faUpload, faFileExcel, faFileVideo, faFilePdf, faFileImage, faFileArchive, faFileAudio, faTimesCircle, faFile, faPhone, faRupeeSign, faPrint, faLockOpen, faDownload, faSignOutAlt, faListOl, faSun, faMoon, faExclamationTriangle, faExclamationCircle, faTrashAlt, faLink, faUnlink, faUserMd, faGraduationCap, faAward, faSchool, faSortDown, faSortUp, faSort, faSortAlphaDown, faSortAlphaUp, faSortAlphaDownAlt, faSortAlphaUpAlt, faHospital, faPhoneAlt, faTh, faThList, faCalendarDay, faFlask, faAngleDoubleUp, faHandsHelping, faHandshake, faInbox, faPaperPlane, faEnvelopeOpen, faSyncAlt, faCloudDownloadAlt, faIndustry, faFileInvoice, faFileInvoiceDollar, faMoneyBillWave
		);
	}
}
